import { fallbackGetAutoShipper } from '../helpers/fallback-autoshipper';

const DIY_NEED_PACKING_MATERIALS = 'DIY_NEED_PACKING_MATERIALS';
const DIY_PACKING_KIT_SELECECTION = 'DIY_PACKING_KIT_SELECTION';
const DIY_TRUCK = 'DIY_TRUCK';
const DIY_NEED_LABOR = 'DIY_NEED_LABOR';
const DIY_LABOR_OPTIONS = 'DIY_LABOR_OPTIONS';
const DIY_AUTO_SHIP = 'DIY_AUTO_SHIP';
const DIY_AUTO_SHIP_DETAILS = 'DIY_AUTO_SHIP_DETAILS';

export const diyState = {
  truck: true,
  packingMaterials: false,
  packingKit: null,
  labor: true,
  laborOptions: null,
  autoShip: true,
  autoShipDetails: {
    cars: [],
    // incase local storage and optimizely fail,
    // pre-populate store with a random shipper.
    // if localStorage and optimizely works this will be overwritten
    shipper: fallbackGetAutoShipper(),
  },
};

export const changeDiyTruck = truck => ({
  type: DIY_TRUCK,
  truck,
});

export const changeDiyPackingMaterials = packingMaterials => ({
  type: DIY_NEED_PACKING_MATERIALS,
  packingMaterials,
});

export const changeDiyPackingKit = packingKit => ({
  type: DIY_PACKING_KIT_SELECECTION,
  packingKit,
});

export const changeDiyLabor = labor => ({
  type: DIY_NEED_LABOR,
  labor,
});

export const changeDiyLaborOptions = laborOptions => ({
  type: DIY_LABOR_OPTIONS,
  laborOptions,
});

export const changeDiyAutoShip = autoShip => ({
  type: DIY_AUTO_SHIP,
  autoShip,
});

export const updateDiyAutoShipDetails = autoShipDetails => ({
  type: DIY_AUTO_SHIP_DETAILS,
  autoShipDetails,
});

export const diyReducer = ({ diy, ...state }, action) => {
  switch (action.type) {
    case DIY_TRUCK:
      return {
        ...state,
        diy: {
          ...diy,
          truck: action.truck,
        },
      };
    case DIY_NEED_PACKING_MATERIALS:
      return {
        ...state,
        diy: {
          ...diy,
          packingMaterials: action.packingMaterials,
        },
      };
    case DIY_PACKING_KIT_SELECECTION:
      return {
        ...state,
        diy: {
          ...diy,
          packingKit: action.packingKit,
        },
      };
    case DIY_NEED_LABOR:
      return {
        ...state,
        diy: {
          ...diy,
          labor: action.labor,
        },
      };
    case DIY_LABOR_OPTIONS:
      return {
        ...state,
        diy: {
          ...diy,
          laborOptions: action.laborOptions,
        },
      };
    case DIY_AUTO_SHIP:
      return {
        ...state,
        diy: {
          ...diy,
          autoShip: action.autoShip,
        },
      };
    case DIY_AUTO_SHIP_DETAILS:
      return {
        ...state,
        diy: {
          ...diy,
          autoShipDetails: {
            ...diy.autoShipDetails,
            ...action.autoShipDetails,
          },
        },
      };
    default: {
      return undefined; // let parent reducer know nothing changed in DIY
    }
  }
};
